import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};
const bodyPartSlice = createSlice({
  name: "bodyPart",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    }
  },
});
export const { setData } = bodyPartSlice.actions;
export default bodyPartSlice.reducer;
